























































import {Vue, Component} from 'vue-property-decorator';
@Component({})
export default class NaverPayGuide extends Vue {
  mounted(){
    $('body').addClass('no-scroll');
  }
  beforeDestroy(){
    $('body').removeClass('no-scroll');
  }
}
